export const queryDetailConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETQUERYDETAIL_REQUEST: 'GETQUERYDETAIL_REQUEST',
    GETQUERYDETAIL_REQUEST_END: 'GETQUERYDETAIL_REQUEST_END',

    GETQUERYDETAIL_SUCCESS: 'GETQUERYDETAIL_SUCCESS',
    GETQUERYDETAIL_FAILURE: 'GETQUERYDETAIL_FAILURE'

};